import React from "react";
import { weightClassOptions } from "../../constants/WeightClassOptions";

const WeightClassSelector = ({
  weightClass,
  onChange,
  fightId,
  isLoading = false,
}) => {
  return (
    <div className={`flex items-center ${isLoading ? "opacity-60" : ""}`}>
      <label
        htmlFor={`weight-class-${fightId}`}
        className="text-dark-grey font-semibold mr-2"
      >
        Weight Class:
      </label>
      {isLoading ? (
        <div className="flex items-center gap-2">
          <svg
            className="w-4 h-4 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              className="opacity-25"
            ></circle>
            <path
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              className="opacity-75"
            ></path>
          </svg>
          <span className="text-sm text-medium-grey">Updating...</span>
        </div>
      ) : (
        <select
          id={`weight-class-${fightId}`}
          className="input"
          value={weightClass}
          onChange={onChange}
          disabled={isLoading}
        >
          {weightClassOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default WeightClassSelector;
